import TabGeneralDetails from './TabGeneralDetails';

export default TabGeneralDetails;
